export const environment = {
    production: false,
    env: 'dev',
    cryptoSecretKey: '$2y$12$IU.ooOzWZh/oiPGSkO4PE.hIGeoOTlo3v6Z14MgdGbwfop9R7rggm',
    meetingURL: 'https://outlook.office.com/bookwithme/user/07452392d1de4489846fe9c7c61f6dcd@finstein.de?anonymous&ep=plink',
    copMeetingURL: 'https://outlook.office.com/bookwithme/user/07452392d1de4489846fe9c7c61f6dcd@finstein.de?anonymous&ep=plink',
    firebaseConfig: {
        apiKey: 'AIzaSyD4bvBq2gI8xAptwoJHZyOx8qXuWU7T1j0',
        authDomain: 'finstein-dev.firebaseapp.com',
        databaseURL: 'https://finstein-rt-dev.europe-west1.firebasedatabase.app/',
        projectId: 'finstein-dev',
        storageBucket: 'finstein-dev.appspot.com',
        messagingSenderId: '276464988372',
        appId: '1:276464988372:web:6d7c9a18c316e8298f0b41',
        measurementId: 'G-BC8MJRLMFS'
    },
    reCaptchaConfigs: {
        siteKey: '6LckAvobAAAAAH40SESd640GdklF3ilgY_Am9T28'
    },
    portalBaseURL: 'https://dev-portal.finstein.com',
    bvmwCertificateURL: 'https://www.bvmw.de/',
    websiteBaseURL: 'https://dev-website.finstein.com',
    faqBaseURL: 'https://faq-finstein-dev.web.app',
    copBaseURL: 'https://dev-beratungs.finstein.com',
    authExpirationTime: 600, // 10min
    authRecoveryTime: 30 // seconds
};
